<template>
  <section class="result-table">
    <table class="table">
      <thead>
        <tr>
          <th>Hand</th>
          <th>Equity</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="generalHand in generalHandsOrderedByEquity" v-bind:key="generalHand.string">
          <td>{{ generalHand.displayString }}</td>
          <td>
            <span v-if="generalHand.equity !== null">{{ generalHand.equity }}%</span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'equity-matrix-result-table',
  props: ['generalHands'],
  computed: {
    generalHandsOrderedByEquity: function () {
      return _.sortBy(this.generalHands._data, function (generalHand) {
        return -generalHand.equity;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .result-table {
    max-height: 440px;
    min-width: 100px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/equity-matrix/result-table.vue